import { memo } from 'react';
import { debounce } from 'lodash';

import { MdSearch } from '@react-icons/all-files/md/MdSearch';
import { InputText, InputTextProps } from '../../../input';

export const SearchField = memo<SearchFieldProps & InputTextProps>(
  ({ handleSearch, placeholder, ...props }) => {
    const debouncedHandleSearch = debounce((value) => {
      handleSearch(value);
    }, 400);

    return (
      <>
        <InputText
          autoFocus
          onChange={(e) => debouncedHandleSearch(e.target.value)}
          placeholder={placeholder}
          identifierIcon={<MdSearch color="#A0A0A0" />}
          fullWidth
          {...props}
        />
      </>
    );
  }
);

interface SearchFieldProps {
  handleSearch: (value: string) => void;
  placeholder?: string;
}
